import React from "react";

import style from "../administration/UserManagement/AirlineRepModal/airlineRepModal.module.css";

import {
  Button,
  Grid,
  withStyles,
  createStyles,
  Theme,
  DialogTitle,
  IconButton,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import AwbBasic from "../../models/AwbBasic";

interface LocationConfirmModalProps {
  modalOpen: boolean;
  handleClose: () => void;
  confirm: (e: any) => void;
  classes: any;
  awbData: AwbBasic;
  disableBtn: boolean;
}

const styles = (theme: Theme) =>
  createStyles({
    formField: {
      height: 40,
      width: "100%",
    },
    rowContainer: {
      paddingRight: 20,
    },
    marginTop10: {
      marginTop: 10,
    },
    closeButton: {
      minWidth: 120,
    },
    processButton: {
      lineHeight: 'normal',
    }
  });

const locationConfirmModal = (props: LocationConfirmModalProps) => {
  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ props.handleClose }
      aria-labelledby="form-dialog-title"
      maxWidth={"sm"}
      fullWidth={true}
    >
      <DialogTitle id="form-dialog-title">
        <div className={ style.dialogTitle }>
          <span className={ style.name }>
            This AWB is for a different location
          </span>
          <IconButton
            aria-label="Close"
            className={ style.close }
            onClick={ props.handleClose }
          >
            <CloseIcon color="primary" />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div>
          <Grid container className={ props.classes.rowContainer }>
            <Grid item xs={12}>
              <div>The airwaybill you are trying to process is:</div>
              <div className={ style.awbData }>
                <p>
                  <strong>Code:</strong> { props.awbData ? props.awbData.code : ''}
                </p>
                <p>
                  <strong>Number:</strong> { props.awbData ? props.awbData.number : ' '}
                </p>
                <p>
                  <strong>Origin:</strong> { props.awbData ? props.awbData.origin: '' }
                </p>
                <p>
                  <strong>Destination:</strong> { props.awbData ? props.awbData.destination: '' }
                </p>
                <p>
                  <strong>Pieces (pcs):</strong> { props.awbData ? props.awbData.pcs : '' }
                </p>
                <p>
                  <strong>Weight:</strong> { props.awbData ? props.awbData.weight : '' }
                </p>
              </div>
            </Grid>
          </Grid>
        </div>
        <div>
          You are not allowed to process this airwaybill as your location does
          not match the origin or destination of the airwaybill.
        </div>
        <div className={ style.confirmBtns }>
          <Button
            color="primary"
            variant="contained"
            onClick={ props.confirm }
            disabled={ !props.disableBtn }
            className={ props.classes.processButton }
          >
            Process Anyway <br />
            (Supervisors & Managers only)
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={ props.handleClose }
            className={ props.classes.closeButton }
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(locationConfirmModal);
